const formatPrice = (price: number): string => {
  return price.toFixed(2).replace('.', ',');
};

const calculateVat = (price: number, vat: number, quantity: number): string => {
  return formatPrice(((price * vat) / 100) * quantity);
};

const calculatePriceWithVat = (price: number, vat: number, quantity: number): string => {
  return formatPrice((price + (price * vat) / 100) * quantity);
};

export { calculatePriceWithVat, calculateVat };
